export default {
	title: "Support",
	newTicket: "Nouveau ticket",
	ticketDetail: "Détails du ticket",
	subject: "Sujet",
	description: "Description",
	category: "Catégorie",
	noTickets: "Aucun ticket trouvé",
	noTicketsDescription: "Vous n'avez encore ouvert aucun ticket de support",
	comments: "Commentaires",
	replyPlaceholder: "Saisissez votre réponse...",
	send: "Envoyer",
	createdAt: "Ouvert le",
	updatedAt: "Mis à jour le",
	backToList: "Retour aux tickets",
	totalTickets: "Total",
	openTickets: "Ouverts",
	attachImage: "Joindre une image",
	categories: {
		BUG: "Bug",
		FEATURE: "Suggestion",
		QUESTION: "Question",
	},
	status: {
		OPEN: "Ouvert",
		IN_PROGRESS: "En cours",
		RESOLVED: "Résolu",
		CLOSED: "Fermé",
	},
	messages: {
		ticketCreated: "Ticket créé avec succès",
		commentAdded: "Réponse envoyée avec succès",
		errorCreating: "Erreur lors de la création du ticket",
		errorLoading: "Erreur lors du chargement des tickets",
		errorAddingComment: "Erreur lors de l'envoi de la réponse",
		imageTooLarge: "Image trop volumineuse. Taille maximale : 5 Mo",
	},
	table: {
		headers: {
			subject: "Sujet",
			category: "Catégorie",
			status: "Statut",
			date: "Date",
			comments: "Réponses",
		},
	},
};
